(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4762);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ SolanaSubLogin; },
  "Z": function() { return /* binding */ container; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@solana/wallet-adapter-react/lib/esm/useWallet.js
var useWallet = __webpack_require__(4306);
// EXTERNAL MODULE: ./node_modules/@solana/wallet-adapter-react-ui/lib/esm/useWalletModal.js
var useWalletModal = __webpack_require__(3495);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 31 modules
var Menu = __webpack_require__(1454);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 3 modules
var MenuItem = __webpack_require__(3599);
;// CONCATENATED MODULE: ./src/components/connect-wallet/view.tsx




const CopyIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_3039_66887)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2 13H3V14H14V15H13V16H1V15H0V4H1V3H2V13Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15 1H16V12H15V13H4V12H3V1H4V0H15V1Z",
                        fill: "currentColor"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_3039_66887",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
const LogoutIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M16 14V2H15V1H14V0H2V1H1V2H0V7H8V6H7V5H6V4H7H8V5H9V6H10V7H11V9H10V10H9V11H8V12H6V11H7V10H8V9H0V14H1V15H2V16H14V15H15V14H16Z",
            fill: "currentColor"
        })
    });
const DownIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M13 6.5H13.5V4.5H11.5V5H11V5.5H10.5V6H10V6.5H9.5V7H9V7.5H8.5V8H7.5V7.5H7V7H6.5V6.5H6V6H5.5V5.5H5V5H4.5V4.5H2.5V6.5H3V7H3.5V7.5H4V8H4.5V8.5H5V9H5.5V9.5H6V10H6.5V10.5H7V11H9V10.5H9.5V10H10V9.5H10.5V9H11V8.5H11.5V8H12V7.5H12.5V7H13V6.5Z",
            fill: "currentColor"
        })
    });
const UserIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4.5 5.81818H3.8V2.90909H4.5V1.45455H5.2V0.727273H6.6V0H9.4V0.727273H10.8V1.45455H11.5V2.90909H12.2V5.81818H11.5V7.27273H10.8V8H9.4V8.72727H6.6V8H5.2V7.27273H4.5V5.81818ZM15 13.0909V15.2727H14.3V16H1.7V15.2727H1V13.0909H1.7V12.3636H2.4V11.6364H3.1V10.9091H4.5V10.1818H11.5V10.9091H12.9V11.6364H13.6V12.3636H14.3V13.0909H15Z",
            fill: "currentColor"
        })
    });
const View = (param)=>{
    let { walletInfo , balance , onClick , menuAnchorEl , menuItems , onMenuClose  } = param;
    const { connected  } = (0,useWallet/* useWallet */.O)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pr-[20px] py-[10px] md:pr-[24px] md:py-[12px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "btn-reset font-ms_serif",
                onClick: onClick,
                children: connected ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row items-center gap-[6px] text-[#f0e9d0b8] hover:text-[#f1c315] text-[14px] leading-[18px] md:gap-[8px] md:text-[16px] md:leading-[20px] md:tracking-[0.64px] md:px-[4px] md:ml-[-4px]",
                    children: [
                        walletInfo,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DownIcon, {})
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[#f0e9d0b8] hover:text-[#F1C315]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row gap-[8px] items-center text-center my-[-6px] ml-[-4px] pl-[4px] pr-[4px]",
                        children: [
                            "Login",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIcon, {})
                        ]
                    })
                })
            }),
            Boolean(menuItems.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                open: Boolean(menuAnchorEl),
                onClose: onMenuClose,
                anchorEl: menuAnchorEl,
                anchorOrigin: {
                    horizontal: "right",
                    vertical: "bottom"
                },
                transformOrigin: {
                    horizontal: "right",
                    vertical: "top"
                },
                MenuListProps: {
                    className: "popup-pixel"
                },
                classes: {
                    paper: "bg-transparent"
                },
                children: menuItems.map((param)=>{
                    let { disabled , keepMenuOpenAfterClick , onClick , testId , text  } = param;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(MenuItem/* default */.Z, {
                        "data-testid": "header-wallet-".concat(testId),
                        disabled: disabled,
                        className: "font-ms_serif text-[#f0e9cf] hover:text-[#F1C315] text-[16px] leading-[20px] flex flex-row items-center justify-between px-[12px] py-[8px] w-[180px]",
                        onClick: ()=>{
                            onClick === null || onClick === void 0 ? void 0 : onClick();
                            !keepMenuOpenAfterClick && (onMenuClose === null || onMenuClose === void 0 ? void 0 : onMenuClose());
                        },
                        children: [
                            text,
                            text === "Logout" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyIcon, {})
                        ]
                    }, text);
                })
            })
        ]
    });
};
const memoView = /*#__PURE__*/ (0,react.memo)(View);
memoView.displayName = "ConnectWallet";
/* harmony default export */ var view = (memoView);

// EXTERNAL MODULE: ./node_modules/@solana/spl-token/lib/index.browser.esm.js + 4 modules
var index_browser_esm = __webpack_require__(4945);
// EXTERNAL MODULE: ./src/providers/solana/index.tsx + 1 modules
var solana = __webpack_require__(3671);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(9417);
;// CONCATENATED MODULE: ./src/components/connect-wallet/container.tsx








const Container = ()=>{
    const { connected , connecting , disconnect , disconnecting , publicKey , wallet  } = (0,useWallet/* useWallet */.O)();
    const { connection , mintPublicKey  } = (0,solana/* useSolana */.X)();
    const { setVisible  } = (0,useWalletModal/* useWalletModal */.h)();
    const [menuAnchorEl, setMenuAnchorEl] = (0,react.useState)();
    const [showCopiedMenuItem, setShowCopiedMenuItem] = (0,react.useState)(false);
    const isWalletConnected = connected && publicKey && wallet;
    const [solCatBalance, setSolCatBalance] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        if (!publicKey || !connection) return;
        const fetchTokenBalance = async ()=>{
            try {
                const ata = await index_browser_esm.Token.getAssociatedTokenAddress(index_browser_esm.ASSOCIATED_TOKEN_PROGRAM_ID, index_browser_esm.TOKEN_PROGRAM_ID, mintPublicKey, publicKey);
                const ataInfo = await connection.getParsedAccountInfo(ata);
                let balance = 0;
                if (ataInfo && ataInfo.value && ataInfo.value.data) {
                    var _ataInfo_value_data_parsed, _ataInfo_value_data_parsed_info, _ataInfo_value_data_parsed_info_tokenAmount;
                    balance = ((_ataInfo_value_data_parsed = ataInfo.value.data.parsed) === null || _ataInfo_value_data_parsed === void 0 ? void 0 : (_ataInfo_value_data_parsed_info = _ataInfo_value_data_parsed.info) === null || _ataInfo_value_data_parsed_info === void 0 ? void 0 : (_ataInfo_value_data_parsed_info_tokenAmount = _ataInfo_value_data_parsed_info.tokenAmount) === null || _ataInfo_value_data_parsed_info_tokenAmount === void 0 ? void 0 : _ataInfo_value_data_parsed_info_tokenAmount.uiAmount) || 0;
                }
                setSolCatBalance(balance);
            } catch (error) {
                console.error("Error fetching token balance:", error);
            }
        };
        fetchTokenBalance();
    }, [
        publicKey
    ]);
    const minifyAddress = function(address) {
        let length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 4;
        if (address.length <= length * 2) {
            return address;
        }
        const firstPart = address.slice(0, length);
        const lastPart = address.slice(-length);
        return "".concat(firstPart, "...").concat(lastPart);
    };
    const handleCopyAddress = (0,react.useCallback)(async ()=>{
        if (publicKey) {
            var _navigator_clipboard;
            await (navigator === null || navigator === void 0 ? void 0 : (_navigator_clipboard = navigator.clipboard) === null || _navigator_clipboard === void 0 ? void 0 : _navigator_clipboard.writeText(publicKey.toBase58()));
            setShowCopiedMenuItem(true);
            setTimeout(()=>setShowCopiedMenuItem(false), 600);
        }
    }, [
        publicKey
    ]);
    (0,react.useEffect)(()=>{
        setMenuAnchorEl(undefined);
    }, [
        isWalletConnected
    ]);
    const menuItems = (0,react.useMemo)(()=>isWalletConnected ? [
            {
                disabled: showCopiedMenuItem,
                keepMenuOpenAfterClick: true,
                onClick: showCopiedMenuItem ? undefined : handleCopyAddress,
                testId: "btn-copy-wallet-address",
                text: showCopiedMenuItem ? "Copied" : "Copy Address"
            },
            {
                onClick: disconnect,
                testId: "btn-disconnect-wallet",
                text: "Logout"
            }
        ] : [], [
        disconnect,
        handleCopyAddress,
        isWalletConnected,
        showCopiedMenuItem,
        setVisible,
        "Copied",
        "Copy Address",
        "Disconnect"
    ]);
    const buttonLabel = isWalletConnected ? minifyAddress(publicKey.toBase58()) : connecting ? "Connecting..." : disconnecting ? "Disconnecting..." : "Connect Wallet";
    const viewProps = (0,react.useMemo)(()=>{
        return {
            icon: wallet === null || wallet === void 0 ? void 0 : wallet.adapter.icon,
            loading: connecting || disconnecting,
            onClick: (e)=>isWalletConnected ? setMenuAnchorEl(e.currentTarget) : setVisible(true),
            walletInfo: buttonLabel,
            balance: solCatBalance,
            menuAnchorEl,
            menuItems,
            onMenuClose: ()=>setMenuAnchorEl(undefined)
        };
    }, [
        buttonLabel,
        connecting,
        disconnecting,
        isWalletConnected,
        menuAnchorEl,
        menuItems,
        setVisible,
        wallet === null || wallet === void 0 ? void 0 : wallet.adapter.icon,
        solCatBalance
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(view, {
        ...viewProps
    });
};
function SolanaSubLogin() {
    const { setVisible  } = (0,useWalletModal/* useWalletModal */.h)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full h-full flex flex-col items-center justify-center min-h-[200px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[#F0E9CF] text-[18px] leading-[22px] md:text-[22px] md:leading-[26px] mt-[4px] mb-[24px]",
                children: "Login to claim"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: "claim-button text-center text-[#100D08E5] text-[16px] leading-[22px] font-ms_serif capitalize p-0",
                onClick: ()=>{
                    setVisible(true);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center my-[-3px] px-[7px]",
                    children: "Login"
                })
            })
        ]
    });
}
/* harmony default export */ var container = (Container);


/***/ }),

/***/ 8925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _container__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _container__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8928);



/***/ }),

/***/ 1880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ MICRO_TOKEN; }
/* harmony export */ });
const MICRO_TOKEN = 1000000; // TODO: based on mint address


/***/ }),

/***/ 9419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useDistributorData; }
/* harmony export */ });
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8767);
/* harmony import */ var _providers_solana__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3671);


const useDistributorData = ()=>{
    const { distributorClient , distributor  } = (0,_providers_solana__WEBPACK_IMPORTED_MODULE_1__/* .useSolana */ .X)();
    const fetchDistributorData = async ()=>{
        if (!distributorClient || !distributor) return null;
        const fetchedData = await distributorClient.ctx.program.account.merkleDistributor.fetchNullable(distributor.key);
        if (!fetchedData) return null;
        return fetchedData;
    };
    return (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)([
        "distributorData",
        distributor === null || distributor === void 0 ? void 0 : distributor.key
    ], fetchDistributorData, {
        enabled: !!(distributor === null || distributor === void 0 ? void 0 : distributor.key),
        staleTime: 1 * 60 * 1000
    });
};


/***/ }),

/***/ 6248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/connect-wallet/index.ts
var connect_wallet = __webpack_require__(8925);
;// CONCATENATED MODULE: ./src/assets/svgs/LogoMark24Icon.svg
/* harmony default export */ var LogoMark24Icon = ({"src":"/_next/static/media/LogoMark24Icon.2e6f037b.svg","height":24,"width":24});
;// CONCATENATED MODULE: ./src/layouts/main-layout/header.tsx





const DesktopHeader = ()=>{
    const [isClient, setIsClient] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setIsClient(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full flex flex-row justify-between items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://app.mattle.fun/",
                className: "h-[62px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: LogoMark24Icon,
                    height: 24,
                    width: 24,
                    alt: "i",
                    className: "mx-[24px] mt-[18px] mb-[20px] text-[#F0E9CF]"
                })
            }),
            isClient && /*#__PURE__*/ (0,jsx_runtime.jsx)(connect_wallet/* default */.Z, {})
        ]
    });
};
const Header = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "fixed top-0 left-0 w-full z-[100] ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopHeader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-[1px] bg-[#493B0C]"
            })
        ]
    });
};
/* harmony default export */ var header = (Header);

;// CONCATENATED MODULE: ./src/layouts/main-layout/index.tsx


const MainLayout = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {}),
            children
        ]
    });
};

;// CONCATENATED MODULE: ./src/layouts/index.tsx



/***/ }),

/***/ 4762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/hooks/use-distributor-data.ts
var use_distributor_data = __webpack_require__(9419);
// EXTERNAL MODULE: ./src/providers/solana/index.tsx + 1 modules
var solana = __webpack_require__(3671);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./node_modules/@coral-xyz/anchor/dist/browser/index.js
var browser = __webpack_require__(9828);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(8456);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(9417);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(1880);
// EXTERNAL MODULE: ./src/utils/apis/merkle-tree.ts
var merkle_tree = __webpack_require__(4725);
;// CONCATENATED MODULE: ./src/hooks/use-merkle-tree.ts


const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
const useProof = (publicKey)=>{
    const LOCAL_STORAGE_KEY = "merkleProof_".concat(publicKey.toString());
    const fetchProof = async ()=>{
        const storedData = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (storedData) {
            const { proof , timestamp  } = JSON.parse(storedData);
            if (Date.now() - timestamp < CACHE_DURATION) {
                return proof;
            }
        }
        const proof1 = await (0,merkle_tree/* fetchMerkleProof */.G)(publicKey);
        const dataToStore = {
            proof: proof1,
            timestamp: Date.now()
        };
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(dataToStore));
        return proof1;
    };
    const { data: proofData , isLoading: isProofLoading , refetch: refetchProof  } = (0,es.useQuery)([
        "proof",
        publicKey
    ], fetchProof, {
        enabled: !!publicKey,
        staleTime: CACHE_DURATION
    });
    const { proof , index , amount  } = proofData !== null && proofData !== void 0 ? proofData : {
        proof: [],
        index: 0,
        amount: 0
    };
    return {
        data: {
            proof,
            index,
            amount
        },
        isLoading: isProofLoading,
        refetch: refetchProof
    };
};

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(7066);
;// CONCATENATED MODULE: ./src/utils/apis/claim.ts

async function updateClaimStatusApi(publicKey) {
    const response = await axios/* default.patch */.Z.patch("".concat("https://api.catsolhat.com/api/v1", "/users/claim"), {}, {
        params: {
            wallet_address: publicKey.toBase58(),
            token_symbol: "MATTLE_PHASE_3"
        }
    });
    return {
        walletAddress: response.data.wallet_address,
        amount: response.data.amount,
        isClaimed: response.data.is_claimed
    };
}

// EXTERNAL MODULE: ./node_modules/react-countdown/dist/index.es.js
var index_es = __webpack_require__(8130);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 4 modules
var Stack = __webpack_require__(7668);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(5861);
;// CONCATENATED MODULE: ./src/components/count-down-content/count-down.tsx
"use client";



const Item = (param)=>{
    let { time , label  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        alignItems: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            className: "text-[#F0E9CF] text-[16px] leading-[22px] md:text-[20px] md:leading-[24px] font-ms_serif ",
            children: "".concat((0,index_es/* zeroPad */.Bu)(time)).concat(label)
        })
    });
};
function CountDown(props) {
    const { date  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.ZP, {
        date: date,
        renderer: (param)=>/*#__PURE__*/ {
            let { days , hours , minutes , seconds  } = param;
            return (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-grow gap-[4px] justify-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                        time: days,
                        label: "d"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                        time: hours,
                        label: "h"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                        time: minutes,
                        label: "m"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                        time: seconds,
                        label: "s"
                    })
                ]
            });
        }
    });
}
/* harmony default export */ var count_down = (CountDown);

;// CONCATENATED MODULE: ./src/components/claim/view.tsx
/* provided dependency */ var Buffer = __webpack_require__(8764)["Buffer"];












const Claim = ()=>{
    const { data: distributorData , error , isLoading  } = (0,use_distributor_data/* useDistributorData */.X)();
    var _distributorData_startTs;
    const startDateTimestamp = Number((_distributorData_startTs = distributorData === null || distributorData === void 0 ? void 0 : distributorData.startTs) !== null && _distributorData_startTs !== void 0 ? _distributorData_startTs : 0);
    const isBeforeAirdropPeriod = startDateTimestamp > Date.now() / 1000;
    const startDate = moment_default()(startDateTimestamp * 1000).format("DD-MM-YYYY");
    var _distributorData_endTs;
    const isAirdropEnded = ((_distributorData_endTs = distributorData === null || distributorData === void 0 ? void 0 : distributorData.endTs) !== null && _distributorData_endTs !== void 0 ? _distributorData_endTs : 0) < Date.now() / 1000;
    const { startTs , endTs  } = distributorData || {
        startTs: 0,
        endTs: 0
    };
    const currentTime = new Date();
    const { connection , provider , program , ctx , distributorClient , mintPublicKey , merkleTreeVersion , distributor , publicKey , connected  } = (0,solana/* useSolana */.X)();
    if (!connection || !provider || !program || !ctx || !distributorClient || !mintPublicKey || !merkleTreeVersion || !distributor || !publicKey) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading..."
        });
    }
    const { data: { proof , index , amount  } , isLoading: isProofLoading , refetch: refetchProof  } = useProof(publicKey);
    const { mutate: claim , isLoading: isClaiming  } = (0,es.useMutation)(async ()=>{
        const claimAmount = new browser.BN(amount);
        const proofBufferArray = proof.map((p)=>Buffer.from(p, "hex"));
        const tx = await distributorClient.newClaim(mintPublicKey, new browser.BN(index), claimAmount, proofBufferArray, new browser.BN(merkleTreeVersion));
        const signature = await tx.buildAndExecute();
        const latestBlockHash = await connection.getLatestBlockhash();
        await connection.confirmTransaction({
            blockhash: latestBlockHash.blockhash,
            lastValidBlockHeight: latestBlockHash.lastValidBlockHeight,
            signature: signature
        });
        await updateClaimStatusApi(publicKey);
    }, {
        onSuccess: ()=>{
            refetchClaimStatus();
        }
    });
    const { data: isClaimed , isLoading: isClaimInfoLoading , refetch: refetchClaimStatus  } = (0,es.useQuery)([
        "isClaimed",
        publicKey
    ], async ()=>{
        if (!publicKey) {
            throw new Error("Public key is null");
        }
        const claimStatusPDA = distributorClient.pda.claim_status(publicKey, distributor.key);
        const accountInfo = await connection.getAccountInfo(claimStatusPDA.key);
        if (!accountInfo) {
            return false;
        }
        const claimStatus = await distributorClient.ctx.program.account.claimStatus.fetch(claimStatusPDA.key);
        return claimStatus.isClaimed;
    }, {
        enabled: connected,
        staleTime: 1 * 60 * 1000
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "font-ms_serif size-full min-h-[200px] flex flex-col",
        children: isProofLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex-1 flex items-center justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                className: "text-[#F0E9CF]"
            })
        }) : proof.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex-1 flex items-center justify-center text-[#F0E9CF] text-[16px] leading-[120%] text-shadow-24 uppercase ",
            children: "Sorry, you are not eligible"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-row justify-between items-center text-[#f0e9cf7a] text-[12px] leading-[16px] md:text-[14px] md:leading-[18px] py-[4px] px-[8px]",
                    children: currentTime.getTime() < startTs * 1000 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "Claim available in:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(count_down, {
                                date: new Date(startTs * 1000)
                            })
                        ]
                    }) : currentTime.getTime() > endTs * 1000 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Claim window has ended!"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "Claim ends in:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(count_down, {
                                date: new Date(endTs * 1000)
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-[1px] w-full bg-[#f0e9cf14] my-[16px]"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-[#F0E9CF] text-shadow-24 text-[16px] leading-[20px] mx-auto text-center pt-[16px]",
                    children: "$MATTLE TO CLAIM"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full relative inline-block text-[78px] leading-[120%] lg:text-[100px] lg:leading-[120%] mx-auto mt-[8px] mb-[20px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute inset-0 text-shadow-6012 lg:text-shadow-918 text-nowrap text-center",
                            children: "".concat(amount / constants/* MICRO_TOKEN */.j)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative text-transparent bg-clip-text bg-gradient-to-b from-[#F8F1FF] to-[#B982EF] text-nowrap text-center",
                            children: "".concat(amount / constants/* MICRO_TOKEN */.j)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-[1px] w-full bg-[#f0e9cf14] my-[16px]"
                }),
                distributorData && (isBeforeAirdropPeriod || isAirdropEnded || isClaimed) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "w-full claim-button-disabled text-center text-[#f0e9cf3d] text-[16px] leading-[22px] font-ms_serif capitalize p-0",
                    disabled: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-[-3px]",
                        children: isClaimed ? "Claimed" : "Claim"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "w-full claim-button text-center text-[#100D08E5] text-[16px] leading-[22px] font-ms_serif capitalize p-0",
                    onClick: ()=>claim(),
                    disabled: isClaiming || isClaimInfoLoading,
                    children: isClaiming || isClaimInfoLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                        size: 22,
                        className: "text-[#F0E9CF] my-[-3px]"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-[-3px]",
                        children: "Claim"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var view = (Claim);

;// CONCATENATED MODULE: ./src/components/claim/index.tsx


// EXTERNAL MODULE: ./src/components/connect-wallet/container.tsx + 1 modules
var container = __webpack_require__(8928);
;// CONCATENATED MODULE: ./src/components/home/view.tsx






const Home = ()=>{
    const { connection , provider , program , ctx , distributorClient , mintPublicKey , merkleTreeVersion , distributor , publicKey , connected  } = (0,solana/* useSolana */.X)();
    const { data: distributorData  } = (0,use_distributor_data/* useDistributorData */.X)();
    var _distributorData_endTs;
    const isAirdropEnded = ((_distributorData_endTs = distributorData === null || distributorData === void 0 ? void 0 : distributorData.endTs) !== null && _distributorData_endTs !== void 0 ? _distributorData_endTs : 0) < Date.now() / 1000;
    if (!connection || !provider || !program || !ctx || !distributorClient || !mintPublicKey || !merkleTreeVersion || !distributor || !publicKey) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "Loading..."
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col items-center w-full md:px-0 lg:px-[40px] font-ms_serif",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex-1 flex flex-col md:flex-row gap-[12px] md:gap-[24px] justify-center md:py-[40px] max-md:max-w-[500px] w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-0 left-0 w-screen h-full",
                    style: {
                        background: "linear-gradient(180deg, #0E0B10 19.63%, #300E46 44.79%, #4C1771 69.11%, #8A31C6 100%), linear-gradient(180deg, #0D0810 19.63%, #311246 44.79%, #4A0D72 69.11%, #9532D7 100%), linear-gradient(180deg, var(--color-background-gradient-default-1, #100D08) 75%, var(--color-yellow-yl08, #282001) 100%)"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute top-0 left-0 w-screen h-full",
                    style: {
                        backgroundImage: "url('/images/claim-background.png')",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "bottom center",
                        opacity: 0.25,
                        mixBlendMode: "luminosity"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-[20px] py-[24px] md:pr-0  lg:px-[64px] md:max-w-[300px] lg:max-w-[613px] w-full flex flex-col gap-[20px] md:gap-[24px] z-[1]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative inline-block text-[40px] leading-[44px] lg:text-[72px] lg:leading-[120%]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "absolute inset-0 text-shadow-48 lg:text-shadow-612 text-nowrap text-left",
                                    children: [
                                        "PHASE 3",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "CLAIM"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative text-transparent bg-clip-text bg-gradient-to-b from-[#F0E9CF] to-[#F1C315] text-nowrap text-left",
                                    children: [
                                        "PHASE 3",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "CLAIM"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grid grid-cols-2 md:grid-cols-1 gap-[20px] md:gap-[24px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-[12px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-[#f0e9cf7a] text-[12px] leading-[16px] md:text-[16px] md:leading-[20px]",
                                        children: "Claim Deadline"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-row gap-[8px] items-center text-[#F0E9CF] text-[16px] leading-[22px] md:text-[20px] md:leading-[24px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-[2px]",
                                            children: "3 PM UTC, Sep 25"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col justify-center max-w-[500px] w-full lg:w-[500px] px-[8px] pb-[20px] md:pb-0 md:pl-0 md:pr-[20px] lg:p-0 z-[1]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pixel-border px-[3px] py-[7px] md:p-[7px]",
                        children: [
                            connected && /*#__PURE__*/ (0,jsx_runtime.jsx)(view, {}),
                            !connected && /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* SolanaSubLogin */.d, {})
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var home_view = (Home);

;// CONCATENATED MODULE: ./src/components/home/index.tsx


// EXTERNAL MODULE: ./src/layouts/index.tsx + 3 modules
var layouts = __webpack_require__(6248);
;// CONCATENATED MODULE: ./src/pages/index.tsx



const Index = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* MainLayout */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-screen h-[100dvh] pt-[63px] box-border flex justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:max-w-[800px] lg:max-w-[1440px] box-border w-full overflow-y-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(home_view, {})
            })
        })
    });
};
/* harmony default export */ var pages = (Index);


/***/ }),

/***/ 4725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ fetchMerkleProof; },
/* harmony export */   "o": function() { return /* binding */ fetchMerkleRoot; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7066);

async function fetchMerkleRoot() {
    const response = await axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat("https://api.catsolhat.com/api/v1", "/merkle_distributor/merkle_root"));
    return {
        merkleRoot: response.data.root,
        totalAmount: response.data.total_amount,
        totalUsers: response.data.total_users
    };
}
async function fetchMerkleProof(publicKey) {
    if (!publicKey) {
        throw new Error("Public key is null");
    }
    const response = await axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("".concat("https://api.catsolhat.com/api/v1", "/merkle_distributor/merkle_proof"), {
        params: {
            wallet_address: publicKey.toBase58(),
            token_symbol: "MATTLE_PHASE_3"
        }
    });
    if (response.status !== 200) {
        console.warn("Failed to fetch proof data, status:", response.status);
        return {
            proof: [],
            index: 0,
            amount: 0
        };
    }
    return {
        proof: response.data.proof,
        index: response.data.index,
        amount: response.data.amount
    };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [885,496,736,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);